var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 325,
    viewBox: "0 0 182 325",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_196_3821)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.9821 11L182 168.018L90.9821 325L0 168.018L90.9821 11Z",
    fill: "url(#paint0_linear_196_3821)",
    fillOpacity: 0.46
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_196_3821)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5734 63.6747L54.6121 137.246L53.0387 140L11 66.4325L12.5734 63.6747ZM48.9613 0L91 73.5675L89.1804 76.7512L47.1417 3.18373L48.9613 0ZM45.3221 6.36747L87.3608 79.935L85.5412 83.1187L43.5025 9.5512L45.3221 6.36747ZM41.6829 12.7349L83.7216 86.3024L81.902 89.4862L39.8633 15.9187L41.6829 12.7349ZM38.0437 19.1024L80.0824 92.6699L78.2628 95.8536L36.2241 22.2861L38.0437 19.1024ZM34.4045 25.4699L76.4432 99.0373L74.6236 102.221L32.5848 28.6536L34.4045 25.4699ZM30.7652 31.8373L72.804 105.405L70.9843 108.589L28.9456 35.0211L30.7652 31.8373ZM27.1302 38.2048L69.1647 111.772L67.3451 114.956L25.3106 41.3886L27.1302 38.2048ZM23.491 44.5723L65.5255 118.144L63.7101 121.328L21.6714 47.756L23.491 44.5723ZM19.8518 50.9398L61.8905 124.511L60.0709 127.695L18.0322 54.1235L19.8518 50.9398ZM16.2126 57.3072L58.2513 130.879L56.4317 134.058L14.393 60.491L16.2126 57.3072Z",
    fill: "url(#paint1_linear_196_3821)",
    fillOpacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_196_3821",
    x: -20,
    y: -9,
    width: 222,
    height: 354,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_196_3821"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_196_3821",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_196_3821",
    x: -5,
    y: -16,
    width: 112,
    height: 172,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_196_3821"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_196_3821",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_196_3821",
    x1: 187.763,
    y1: 289.578,
    x2: -39.3128,
    y2: 252.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A3EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FF4E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_196_3821",
    x1: 93.5332,
    y1: 124.207,
    x2: -6.35261,
    y2: 108.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2CDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#099B91"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage3);
export default __webpack_public_path__ + "static/media/image-3.b4d2a627bfc852fec64d4f9544471508.svg";
export { ForwardRef as ReactComponent };